import { z } from 'zod';

export const DualWriteStatsSchema = z.object({
  metrics: z.object({
    writes: z.number(),
    creates: z.number(),
    updates: z.number(),
    skips: z.number(),
    errors: z.number(),
    warnings: z.number(),
  }),
  coverage: z.object({
    totalLegacy: z.number(),
    bridgedCount: z.number(),
    totalV4: z.number(),
    coveragePercent: z.number(),
  }),
  instanceStartedAt: z.string(),
  legacyFieldLookups: z.array(z.object({ field: z.string(), source: z.string() })),
});

export type DualWriteStats = z.infer<typeof DualWriteStatsSchema>;
